// InvitesList.tsx — center-column invites list (Invitations tab). Accept/Decline decorative.
import styled from 'styled-components';
import { ConsolePanel, Button, useToast } from '@/ui';
import { useRequireAuth } from '@/hooks';
import { CommunityIcon } from './CommunityIcon';
import type { CommunityInvite } from '@/core/models/community';

const List = styled.div`display: flex; flex-direction: column; gap: 10px;`;
const Row = styled(ConsolePanel)`display: flex; align-items: center; gap: 12px;`;
const Info = styled.div`flex: 1; min-width: 0; display: flex; flex-direction: column;`;
const Name = styled.span`font-family: ${({ theme }) => theme.font.body}; font-weight: 600; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textPrimary};`;
const Sub = styled.span`font-family: ${({ theme }) => theme.font.mono}; font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted};`;
const Actions = styled.div`display: flex; gap: 8px;`;
const Empty = styled.div`padding: 28px 16px; text-align: center; font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted}; background: ${({ theme }) => (theme.cardsGlass ? 'transparent' : theme.color.surface)}; border-radius: ${({ theme }) => theme.radius.md};`;

export function InvitesList({ invites }: { invites: CommunityInvite[] }) {
  const toast = useToast();
  const requireAuth = useRequireAuth();
  function act(label: string) {
    if (!requireAuth('respond to invites')) return;
    toast(`${label}: invites are coming soon`);
  }
  if (invites.length === 0) return <Empty>No pending invitations.</Empty>;
  return (
    <List>
      {invites.map((inv) => (
        <Row key={inv.id}>
          <CommunityIcon svg={inv.icon} size={40} />
          <Info>
            <Name>{inv.name}</Name>
            <Sub>{inv.members}</Sub>
          </Info>
          <Actions>
            <Button variant="primary" size="sm" onClick={() => act('Accepted')}>Accept</Button>
            <Button variant="secondary" size="sm" onClick={() => act('Declined')}>Decline</Button>
          </Actions>
        </Row>
      ))}
    </List>
  );
}
